import ToBooleanText from '../../components/utilities/Table/helperKIvaTable';
import { RequestWarranty } from '../../components/utilities/Table/generalColumns/RequestWarranty';

const commonColumns = [
    RequestWarranty,
    {
        Header: 'Estado',
        accessor: 'estado.label',
    },
    ToBooleanText('tramite', 'Tramite voluntario', 'tramite_voluntario'),
    {
        Header: 'Identificación',
        accessor: 'solicitud.persona.numero_identificacion',
    },

    {
        Header: 'Cliente',
        accessor: 'solicitud.persona.full_name',
        typeId: 'HeaderClient',
    },
    {
        Header: 'Nro crédito',
        accessor: 'credito.num_credito',
    },

    {
        Header: 'Producto',
        accessor: 'credito.subproducto.label',
    },

    {
        Header: 'Placa',
        accessor: 'solicitud.vehiculossolicitud.placa_vehiculo',
    },
];

const requestsWarrantyList = [
    {
        id: 'en_proceso',
        label: 'GARANTÍA VEHICULAR',
        status: '1,2,3,4,5,6,7,8,11,9',
        offices: true,
        responsable: null,
        columns: (() => {
            const cols = [...commonColumns];
            cols.splice(1, 0, {
                Header: 'Fecha creación',
                accessor: 'gestiongmv.fecha_creacion',
            });
            return cols;
        })(),
        registrationLimit: 5,
        apiSolicitud: false,
        // nameColumnProcessed: [
        //     {
        //         name: 'estado',
        //         value: 2,
        //         operator: '%26',
        //     },
        // ],
    },
];
export default requestsWarrantyList;
